var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27850",
    "data-name": "Group 27850",
    transform: "translate(-109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3041",
    "data-name": "Rectangle 3041",
    width: 20,
    height: 20,
    transform: "translate(109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27652",
    "data-name": "Group 27652",
    transform: "translate(112.001 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27641",
    "data-name": "Group 27641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect",
    width: 13.5,
    height: 13.4,
    rx: 2,
    transform: "translate(0 1.6)",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    y2: 3.2,
    transform: "translate(9.75)",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-2",
    "data-name": "Line",
    y2: 3.2,
    transform: "translate(3.75)",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-3",
    "data-name": "Line",
    x2: 13.5,
    transform: "translate(0 6)",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_403",
    "data-name": "Line 403",
    x2: 5.76,
    transform: "translate(5.265 8.647)",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_404",
    "data-name": "Line 404",
    x1: 3.922,
    transform: "translate(7.239 10.941)",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.b86a7fa1791c61ccd8a10616213901af.svg";
export { ForwardRef as ReactComponent };